import { apiRequest } from "../../../../shared/lib/api";
import { SiteContent } from "../types/siteContent";

export function getSiteContent() {
  return apiRequest<SiteContent>("/api/site-content");
}

export function updateSiteContent(token: string, content: SiteContent) {
  return apiRequest<{ ok: boolean; content: SiteContent }>("/api/site-content", {
    method: "PUT",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify(content),
  });
}
